// extracted by mini-css-extract-plugin
export default {"container":"GJ-z","dimension":"HJ-z","dimensionLabels":"IJ-z"};